export default __webpack_public_path__ + "static/03-a39d9da4c74cbf05001c6ad1e6f56d89.jpg";